import {containers,actionTypes,uiItemNames,buttonActionTypes, revMode, currPathValue, docPathValue} from '../types/enums'
import {ReqError, PaDocument, NewMetaItemValues, MetaItem, MetaItemValue,MetaItemPresentation, PaFile} from '../types/types'
import {ThunkDispatch} from 'redux-thunk'
import {AppActions,ThunkResult,IState} from '../types/types'
import {callProArcApi} from '../components/helpers/proarcApiHelpers';
import store from '../configureStore';
import { NewRevisionJson, getRevisionsJson, saveRevisionJson} from './jsons';
import _ from "lodash";
import { setAppSettings, setStateItem, setUiProperty } from './actionsBase';

const apiUrl = "__API_URL__";

export function setContainersVisible(currentPath:currPathValue, requestId:string):ThunkResult<void> {
    console.log("setContainersVisible", currentPath);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
                dispatch(setUiProperty(actionTypes.SET_VISIBLE,containers.MAIN_CONTAINER, true));
                dispatch(setUiProperty(actionTypes.SET_LOADING, containers.MAIN_CONTAINER, true));
                
                const json = {
                    "repositoryRno": 0,
                    "section": "PROARC_EXT"
                  }; 
                dispatch(()=>callProArcApi(buttonActionTypes.GET_CONFIG,json,"")
                    .then((response)=>{
                        if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                            {
                                console.log("Error");
                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response)));  
                                dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                                dispatch(setUiProperty(actionTypes.SET_LOADING, containers.MAIN_CONTAINER, false));  
                            }
                        else
                            {
                                //store config
                                dispatch(setAppSettings(actionTypes.SET_APP_SETINGS, JSON.parse((response as any)[0].value)));    

                                let extensionBtnName = "";
                                switch ((currentPath || '').toLowerCase()) {
                                    case currPathValue.massUpdateRevisions.toLowerCase():
                                        extensionBtnName = "massUpdateRevisions";
                                    break;
                                    case currPathValue.transferToProteknisk.toLowerCase():
                                        extensionBtnName = "transferToProteknisk";
                                    break;
                                    case currPathValue.pdfConvert.toLowerCase():
                                        extensionBtnName = "pdfConvert";
                                    break;
                                    case currPathValue.commentSheet.toLowerCase():
                                        extensionBtnName = "commentSheet";
                                    break;
                                    case currPathValue.transferHistoriskToFdv.toLowerCase():
                                        extensionBtnName = "transferHistoriskToFdv";
                                    break;
                                    case currPathValue.transferFromProtekniskToTos.toLowerCase():
                                        extensionBtnName = "transferFromProtekniskToTos";
                                    break;
                                    default:
                                        extensionBtnName = "";
                                    }

                                const JsonPost={"extensionBtnName": extensionBtnName}

                                dispatch(()=>callProArcApi(buttonActionTypes.CHECK_ACCESS_TO_EXTENTION,JsonPost,"")
                                    .then((response)=>{
                                            if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                            {
                                                console.log("Error");
                                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                                                dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                                                dispatch(setUiProperty(actionTypes.SET_LOADING, containers.MAIN_CONTAINER, false));
                                            }
                                            else
                                            {
                                                //success
                                                const hasAccess = (response as unknown as any).message.toString().toLowerCase()==="true" ? true : false;
                                                if(hasAccess)
                                                {
                                                    //has access load data
                                                    switch ((currentPath || '').toLowerCase()) {
                                                        case currPathValue.massUpdateRevisions.toLowerCase():
                                                            dispatch(loadMassUpdateRevisionsList(requestId));
                                                        break;
                                                        case currPathValue.transferToProteknisk.toLowerCase():
                                                            dispatch(loadDocumentList(requestId));
                                                        break;
                                                        case currPathValue.pdfConvert.toLowerCase():
                                                            dispatch(loadPdfConvertList(requestId));
                                                        break;
                                                        case currPathValue.commentSheet.toLowerCase():
                                                            dispatch(loadCommentSheetList(requestId));
                                                        break;
                                                        case currPathValue.transferHistoriskToFdv.toLowerCase():
                                                            dispatch(loadDocumentList(requestId));
                                                        break;
                                                        case currPathValue.transferFromProtekniskToTos.toLowerCase():
                                                            dispatch(loadDocumentList(requestId));
                                                        break;
                                                        default:
                                                            dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, false));    
                                                            dispatch(setUiProperty(actionTypes.SET_LOADING,containers.MAIN_CONTAINER, false));
                                                    }
                                                }
                                                else{
                                                    //set no access flag
                                                    dispatch(setUiProperty(actionTypes.HAS_ACCESS,containers.MAIN_CONTAINER, false));
                                                    dispatch(setUiProperty(actionTypes.SET_LOADING,containers.MAIN_CONTAINER, false));
                                                }                        
                                            }
                                        })
                                        .catch(error=>
                                            {
                                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(error)));      
                                                dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                                                dispatch(setUiProperty(actionTypes.SET_LOADING,containers.MAIN_CONTAINER, false));
                                            }
                                        )
                                );
                            }
                        })
                        .catch(error=>
                            {
                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error)));      
                                dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                                dispatch(setUiProperty(actionTypes.SET_LOADING, containers.MAIN_CONTAINER, false));
                            }
                        )    
                )
    }            
};

// export function loadConfig():ThunkResult<void>
// {
//     console.log("loadConfig");
//     return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
//         dispatch(setUiProperty(actionTypes.SET_VISIBLE,containers.MAIN_CONTAINER, true));
//         dispatch(setUiProperty(actionTypes.SET_LOADING,containers.MAIN_CONTAINER, true));
        
//         const json = {
//                     "repositoryRno": 0,
//                     "section": "PROARC_EXT"
//                   };
//         dispatch(()=>callProArcApi(buttonActionTypes.GET_CONFIG,json,"")
//             .then((response)=>{
//                 if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
//                     {
//                         console.log("Error");
//                         dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(response)));    
//                     }
//                 else
//                     {
//                         //store config
//                         dispatch(setAppSettings(actionTypes.SET_APP_SETINGS, JSON.parse((response as any)[0].value)));    
//                         dispatch(setUiProperty(actionTypes.SET_LOADING, containers.MAIN_CONTAINER, false));
//                     }
//                 })
//                 .catch(error=>
//                     {
//                         dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMessage, JSON.stringify(error)));      
//                         dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
//                         dispatch(setUiProperty(actionTypes.SET_LOADING, containers.MAIN_CONTAINER, false));
//                     }
//                 )    
//         )
//     }
// }

export function MetaItemValueChange(newValue: MetaItemValue):ThunkResult<void> {
    console.log("MetaItemValueChange");
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
                // console.log("newValue",newValue);
                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, newValue));
    }            
};

export function ApplyToAll(value: any, selection: readonly string[]):ThunkResult<void> {
    // console.log("ApplyToAll", value, selection);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
                if(value.DocumentID === "REVISION")
                {
                    let docData = store.getState().uiItems.documentList;
                    docData.forEach((element:PaDocument) => {
                        // console.log("includes",selection.includes(element.DocId),"lenght",selection.length)
                        if(selection.includes(element.DocId) || selection.length === 0)
                        {
                            value.DocumentID = element.DocId;
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, value));
                        }
                    });                
                }
                else
                {
                    let docData = store.getState().uiItems.documentList;
                    docData.forEach((element:PaDocument) => {
                        element.RevisionToUpdate.Files.forEach((file:PaFile) => {
                            // console.log("includes",selection.includes(file.Name),"lenght",selection.length)
                            if(selection.includes(file.Name) || selection.length === 0)
                            {
                                value.DocumentID = file.Name;
                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, value));
                            } 
                        });
                    });  
                }
                
    }            
};

export function RevModeChange(value: revMode):ThunkResult<void> {
    console.log("RevModeChange");
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
                dispatch(setStateItem(actionTypes.CLEAR_ITEMS, uiItemNames.newMetaItemValues, ""));
                //console.log("value",value);
                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.revToUpdate, value));    
                store.getState().uiItems.documentList.forEach((doc:PaDocument)=>{
                    let rev2Update = _.cloneDeep(
                            (value === revMode.LATEST_REV) ?
                                (doc.Revisions[0].$ref === undefined) ? doc.Revisions[0] : doc.CurrentRevision
                                : doc.CurrentRevision
                        );
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListUpdate, {DocumentID: doc.DocId, Attribute: "RevisionToUpdate",  Value: rev2Update}));  
                });
    }            
};

export function DPIChange(dpi: number):ThunkResult<void> {
    console.log("DPIChange");
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
                //console.log("value",dpi);
                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.DPI, dpi));    
    }            
};


export function LevelChange(value: boolean):ThunkResult<void> {
    console.log("LevelChange");
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
                dispatch(setStateItem(actionTypes.CLEAR_ITEMS, uiItemNames.newMetaItemValues, ""));
                // console.log("value",value);
                if(value === true && store.getState().uiItems.MetaItemPresentations === null)
                {
                    dispatch(setUiProperty(actionTypes.SET_LOADING,containers.REVISION_LIST_CONTAINER, true));
                    dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.REVISION_LIST_CONTAINER, false));

                    let JsonPost = {
                        "dbRno": store.getState().uiItems.documentList[0].DbRno
                    }

                    dispatch(()=>callProArcApi(buttonActionTypes.GET_METAITEMPRESENTATION,JsonPost,"")
                        .then((response)=>{
                                if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                {
                                    console.log("Error");
                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                                    dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.REVISION_LIST_CONTAINER, true));
                                }
                                else
                                {
                                    console.log("Success", response);
                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.MetaItemPresentations, response));
       
                                    let dropdownsToGet:MetaItemPresentation[] =  store.getState().uiItems.MetaItemPresentations!.MetaItemPresentations.filter((x:MetaItemPresentation) =>x.Enabled === true && x.Visible === true && x.ShowDropDownIcon===true);
                                    //console.log("dropdownsToGet", dropdownsToGet);

                                    if(dropdownsToGet.length>0)
                                    {
                                        let p = Promise.resolve();
                                        dropdownsToGet.forEach((value:MetaItemPresentation) =>
                                            p = p.then(() => getValidValues(value,dispatch))
                                            .finally(()=> {
                                                dispatch(setUiProperty(actionTypes.SET_LOADING,containers.REVISION_LIST_CONTAINER, false));
                                            }))
                                    }
                                    else
                                    {
                                        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.REVISION_LIST_CONTAINER, false));
                                    }
                                    
                                }   
                            }
                        )
                        .catch(error=>
                            {
                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(error)));      
                                dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.REVISION_LIST_CONTAINER, true));
                                dispatch(setUiProperty(actionTypes.SET_LOADING,containers.REVISION_LIST_CONTAINER, false));
                            }
                        )
                    )  
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.levelToUpdate, value));   
                }
                else
                {
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.levelToUpdate, value));    
                }
                    
    }            
};

export function setMassUpdateRevisionsVisible(requestId:string):ThunkResult<void> {
    console.log("setMassUpdateRevisionsVisible", requestId);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        dispatch(setUiProperty(actionTypes.SET_VISIBLE,containers.REVISION_LIST_CONTAINER, true))
        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.REVISION_LIST_CONTAINER, true))

        const JsonPost={"extensionBtnName": "massUpdateRevisions"}
        dispatch(()=>callProArcApi(buttonActionTypes.CHECK_ACCESS_TO_EXTENTION,JsonPost,"")
            .then((response)=>{
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                        dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.REVISION_LIST_CONTAINER, true));
                    }
                    else
                    {
                        //success
                        const hasAccess = (response as unknown as any).message.toString().toLowerCase()==="true" ? true : false;
                        if(hasAccess)
                        {
                            //has access load data
                            dispatch(loadMassUpdateRevisionsList(requestId));
                        }
                        else{
                            //set no access flag
                            dispatch(setUiProperty(actionTypes.HAS_ACCESS,containers.REVISION_LIST_CONTAINER, false));
                        }                        
                    }
                })
                .catch(error=>
                    {
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(error)));      
                        dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.REVISION_LIST_CONTAINER, true));
                        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.REVISION_LIST_CONTAINER, false));
                    }
                )
        );
    }            
};

function LoadMetaItemPresentation(DbRnoOnFirstDoc:number,dispatch:ThunkDispatch<IState,undefined,AppActions>):Promise<void>
{
    console.log("LoadMetaItemPresentation");
    dispatch(setStateItem(actionTypes.CLEAR_ITEMS, uiItemNames.newMetaItemValues, ""));
    if(store.getState().uiItems.MetaItemPresentations === null)
    { 
        let JsonPost = {
            "dbRno": DbRnoOnFirstDoc
        }

        return callProArcApi(buttonActionTypes.GET_METAITEMPRESENTATION,JsonPost,"")
                .then((response)=>{
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                        dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.REVISION_LIST_CONTAINER, true));
                    }
                    else
                    {
                        //console.log("Success", response);
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.MetaItemPresentations, response));

                        let dropdownsToGet:MetaItemPresentation[] =  store.getState().uiItems.MetaItemPresentations!.MetaItemPresentations.filter((x:MetaItemPresentation) =>x.Enabled === true && x.Visible === true && x.ShowDropDownIcon===true);
                        //console.log("dropdownsToGet", dropdownsToGet);

                        if(dropdownsToGet.length>0)
                        {
                            let p = Promise.resolve();
                            dropdownsToGet.forEach((value:MetaItemPresentation) =>
                                p = p.then(() => getValidValues(value,dispatch))
                            )
                        }                        
                    }   
                }
            )        
    }
    else
    {
        return Promise.resolve()  
    }  
}     

export function setPdfConvertVisible(requestId:string):ThunkResult<void> {
    console.log("setPdfConvertVisible", requestId);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        dispatch(setUiProperty(actionTypes.SET_VISIBLE,containers.PDF_CONVERT_CONTAINER, true))
        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_CONVERT_CONTAINER, true))

        const JsonPost={"extensionBtnName": "pdfConvert"}
        dispatch(()=>callProArcApi(buttonActionTypes.CHECK_ACCESS_TO_EXTENTION,JsonPost,"")
            .then((response)=>{
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                        dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.PDF_CONVERT_CONTAINER, true));
                    }
                    else
                    {
                        //success
                        const hasAccess = (response as unknown as any).message.toString().toLowerCase()==="true" ? true : false;
                        if(hasAccess)
                        {
                            //has access load data
                            dispatch(loadPdfConvertList(requestId));
                        }
                        else{
                            //set no access flag
                            dispatch(setUiProperty(actionTypes.HAS_ACCESS,containers.PDF_CONVERT_CONTAINER, false));
                        }                        
                    }
                })
                .catch(error=>
                    {
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(error)));      
                        dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.PDF_CONVERT_CONTAINER, true));
                        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_CONVERT_CONTAINER, false));
                    }
                )
        );
    }            
};

export function setCommentSheetVisible(requestId:string):ThunkResult<void> {
    console.log("setCommentSheetVisible", requestId);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        dispatch(setUiProperty(actionTypes.SET_VISIBLE,containers.COMMENT_SHEET_CONTAINER, true))
        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.COMMENT_SHEET_CONTAINER, true))

        const JsonPost={"extensionBtnName": "commentSheet"}
        dispatch(()=>callProArcApi(buttonActionTypes.CHECK_ACCESS_TO_EXTENTION,JsonPost,"")
            .then((response)=>{
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                        dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.COMMENT_SHEET_CONTAINER, true));
                    }
                    else
                    {
                        //success
                        const hasAccess = (response as unknown as any).message.toString().toLowerCase()==="true" ? true : false;
                        if(hasAccess)
                        {
                            //has access load data
                            dispatch(loadCommentSheetList(requestId));
                        }
                        else{
                            //set no access flag
                            dispatch(setUiProperty(actionTypes.HAS_ACCESS,containers.COMMENT_SHEET_CONTAINER, false));
                        }                        
                    }
                })
                .catch(error=>
                    {
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(error)));      
                        dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.COMMENT_SHEET_CONTAINER, true));
                        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.COMMENT_SHEET_CONTAINER, false));
                    }
                )
        );
    }            
};

export function loadCommentSheetList(requestId:string):ThunkResult<void> {
    console.log("loadCommentSheetList",requestId);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        //let postJson;
        dispatch(setStateItem(actionTypes.CLEAR_ITEMS, uiItemNames.infoContainerItems, ""));      
        dispatch(setStateItem(actionTypes.CLEAR_ITEMS, uiItemNames.documentList, ""));      
        dispatch(setStateItem(actionTypes.CLEAR_ITEMS, uiItemNames.newMetaItemValues, ""));    
        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.levelToUpdate, true));    
        // dispatch(setUiProperty(actionTypes.SET_VISIBLE,containers.COMMENT_SHEET_CONTAINER, true));
        // dispatch(setUiProperty(actionTypes.SET_LOADING,containers.COMMENT_SHEET_CONTAINER, true));
        // dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.COMMENT_SHEET_CONTAINER, false));
        let JsonPost = 
        {
            "propertyName": requestId
        }

        dispatch(()=>callProArcApi(buttonActionTypes.GET_WEB_REQUEST,JsonPost,"")
            .then((response)=>{
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                        dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                    }
                    else
                    {
                        //console.log("Success", response);
                        let JsonPostDocuments = {
                            "docRnos": [-1],
                            "returnOptions": "All"
                            };
                        JsonPostDocuments.docRnos = JSON.parse((response as unknown as any)._success.PropertyValue).DocRnos;
                        dispatch(()=>callProArcApi(buttonActionTypes.GET_DOCUMENTS,JsonPostDocuments,"")
                            .then((response)=>{
                                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                    {
                                        console.log("Error");
                                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                                        dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                                    }
                                    else
                                    {
                                        console.log("Success");
                                        let docs = (response as any as PaDocument[]).map((doc:PaDocument)=> {
                                            return {    
                                                DocId: doc.DocId,
                                                DbRno: doc.DbRno,
                                                DocRno: doc.DocRno,
                                                CurrentRevision: doc.CurrentRevision,
                                                Revisions: doc.Revisions
                                            }
                                        })
                                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentList, docs));
                                        //dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentList, response));
                                        //set revision to update
                                        let revModeSelected = store.getState().uiItems.revToUpdate; 
                                        store.getState().uiItems.documentList.forEach((doc:PaDocument)=>{
                                            let rev2Update = _.cloneDeep(
                                                    (revModeSelected === revMode.LATEST_REV) ?
                                                        (doc.Revisions[0].$ref === undefined) ? doc.Revisions[0] : doc.CurrentRevision
                                                        : doc.CurrentRevision
                                                );
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListUpdate, {DocumentID: doc.DocId, Attribute: "RevisionToUpdate",  Value: rev2Update}));  
                                        });
                                        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.MAIN_CONTAINER, false))
                                    }
                            })
                        )
                    }   
                }
            )
            .catch(error=>
                {
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(error)));      
                    dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                    dispatch(setUiProperty(actionTypes.SET_LOADING,containers.MAIN_CONTAINER, false));
                }
            )   
        );            
    }    
} 

export function loadPdfConvertList(requestId:string):ThunkResult<void> {
    console.log("loadPdfConvertList",requestId);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        //let postJson;
        dispatch(setStateItem(actionTypes.CLEAR_ITEMS, uiItemNames.infoContainerItems, ""));      
        dispatch(setStateItem(actionTypes.CLEAR_ITEMS, uiItemNames.documentList, ""));      
        dispatch(setStateItem(actionTypes.CLEAR_ITEMS, uiItemNames.newMetaItemValues, ""));    
        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.levelToUpdate, true));    
        // dispatch(setUiProperty(actionTypes.SET_VISIBLE,containers.PDF_CONVERT_CONTAINER, true));
        // dispatch(setUiProperty(actionTypes.SET_LOADING,containers.PDF_CONVERT_CONTAINER, true));
        // dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.PDF_CONVERT_CONTAINER, false));
        let JsonPost = 
        {
            "propertyName": requestId
        }

        dispatch(()=>callProArcApi(buttonActionTypes.GET_WEB_REQUEST,JsonPost,"")
            .then((response)=>{
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                        dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                    }
                    else
                    {
                        //console.log("Success", response);
                        let JsonPostDocuments = {
                            "docRnos": [-1],
                            "returnOptions": "All"
                            };
                        JsonPostDocuments.docRnos = JSON.parse((response as unknown as any)._success.PropertyValue).DocRnos;
                        dispatch(()=>callProArcApi(buttonActionTypes.GET_DOCUMENTS,JsonPostDocuments,"")
                            .then((response)=>{
                                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                    {
                                        console.log("Error");
                                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                                        dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                                    }
                                    else
                                    {
                                        console.log("Success");
                                        let docs = (response as any as PaDocument[]).map((doc:PaDocument)=> {
                                            return {    
                                                DocId: doc.DocId,
                                                DbRno: doc.DbRno,
                                                DocRno: doc.DocRno,
                                                CurrentRevision: doc.CurrentRevision,
                                                Revisions: doc.Revisions
                                            }
                                        })
                                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentList, docs));
                                        //dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentList, response));
                                        //set revision to update
                                        let revModeSelected = store.getState().uiItems.revToUpdate; 
                                        store.getState().uiItems.documentList.forEach((doc:PaDocument)=>{
                                            let rev2Update = _.cloneDeep(
                                                    (revModeSelected === revMode.LATEST_REV) ?
                                                        (doc.Revisions[0].$ref === undefined) ? doc.Revisions[0] : doc.CurrentRevision
                                                        : doc.CurrentRevision
                                                );
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListUpdate, {DocumentID: doc.DocId, Attribute: "RevisionToUpdate",  Value: rev2Update}));  
                                        });
                                        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.MAIN_CONTAINER, false))
                                    }
                            })
                        )
                    }   
                }
            )
            .catch(error=>
                {
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(error)));      
                    dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                    dispatch(setUiProperty(actionTypes.SET_LOADING,containers.MAIN_CONTAINER, false));
                }
            )   
        );            
    }    
} 

export function setTransferToProtekniskVisible(requestId:string):ThunkResult<void> {
    console.log("setTransferToProtekniskVisible", requestId);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        dispatch(setUiProperty(actionTypes.SET_VISIBLE,containers.TRANSFER_FDV_CONTAINER, true))
        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.TRANSFER_FDV_CONTAINER, true))

        const JsonPost={"extensionBtnName": "TransferToProteknisk"}
        dispatch(()=>callProArcApi(buttonActionTypes.CHECK_ACCESS_TO_EXTENTION,JsonPost,"")
            .then((response)=>{
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                        dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.TRANSFER_FDV_CONTAINER, true));
                    }
                    else
                    {
                        //success
                        const hasAccess = (response as unknown as any).message.toString().toLowerCase()==="true" ? true : false;
                        if(hasAccess)
                        {
                            //has access load data
                            dispatch(loadDocumentList(requestId));
                        }
                        else{
                            //set no access flag
                            dispatch(setUiProperty(actionTypes.HAS_ACCESS,containers.TRANSFER_FDV_CONTAINER, false));
                        }                        
                    }
                })
                .catch(error=>
                    {
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(error)));      
                        dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.TRANSFER_FDV_CONTAINER, true));
                        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.TRANSFER_FDV_CONTAINER, false));
                    }
                )
        );
    }            
};

export function loadDocumentList(requestId:string):ThunkResult<void> {
    console.log("loadDocumentList",requestId);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        //let postJson;
        dispatch(setStateItem(actionTypes.CLEAR_ITEMS, uiItemNames.infoContainerItems, ""));      
        dispatch(setStateItem(actionTypes.CLEAR_ITEMS, uiItemNames.documentList, ""));         
        // dispatch(setUiProperty(actionTypes.SET_VISIBLE,containers.TRANSFER_FDV_CONTAINER, true));
        // dispatch(setUiProperty(actionTypes.SET_LOADING,containers.TRANSFER_FDV_CONTAINER, true));
        // dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.TRANSFER_FDV_CONTAINER, false));
        let JsonPost = 
        {
            "propertyName": requestId
        }

        dispatch(()=>callProArcApi(buttonActionTypes.GET_WEB_REQUEST,JsonPost,"")
            .then((response)=>{
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                        dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                    }
                    else
                    {
                        //console.log("Success", response);
                        let JsonPostDocuments = {
                            "docRnos": [-1],
                            "returnOptions": "All"
                            };
                        JsonPostDocuments.docRnos = JSON.parse((response as unknown as any)._success.PropertyValue).DocRnos;
                        dispatch(()=>callProArcApi(buttonActionTypes.GET_DOCUMENTS,JsonPostDocuments,"")
                            .then((response)=>{
                                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                    {
                                        console.log("Error");
                                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                                        dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                                    }
                                    else
                                    {
                                        console.log("Success");
                                        let docs = (response as any as PaDocument[]).map((doc:PaDocument)=> {
                                            return {    
                                                DocId: doc.DocId,
                                                DbRno: doc.DbRno,
                                                MetaItems: doc.MetaItems,
                                                DocRno: doc.DocRno,
                                                CurrentRevision: doc.CurrentRevision,
                                                Revisions: doc.Revisions
                                            }
                                        })
                                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentList, docs));
                                        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.MAIN_CONTAINER, false));
                                    }
                            })
                        )
                    }   
                }
            )
            .catch(error=>
                {
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(error)));      
                    dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                    dispatch(setUiProperty(actionTypes.SET_LOADING,containers.MAIN_CONTAINER, false));
                }
            )   
        );            
    }    
} 

export function loadMassUpdateRevisionsList(requestId:string):ThunkResult<void> {
    console.log("loadMassUpdateRevisionsList",requestId);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        //let postJson;
        dispatch(setStateItem(actionTypes.CLEAR_ITEMS, uiItemNames.infoContainerItems, ""));      
        dispatch(setStateItem(actionTypes.CLEAR_ITEMS, uiItemNames.documentList, ""));      
        dispatch(setStateItem(actionTypes.CLEAR_ITEMS, uiItemNames.newMetaItemValues, ""));      
        // dispatch(setUiProperty(actionTypes.SET_VISIBLE,containers.REVISION_LIST_CONTAINER, true));
        // dispatch(setUiProperty(actionTypes.SET_LOADING,containers.REVISION_LIST_CONTAINER, true));
        // dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.REVISION_LIST_CONTAINER, false));
        let JsonPost = 
        {
            "propertyName": requestId
        }

        dispatch(()=>callProArcApi(buttonActionTypes.GET_WEB_REQUEST,JsonPost,"")
            .then((response)=>{
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                        dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                    }
                    else
                    {
                        //console.log("Success", response);
                        let JsonPostDocuments = {
                            "docRnos": [-1],
                            "returnOptions": "All"
                            };
                        JsonPostDocuments.docRnos = JSON.parse((response as unknown as any)._success.PropertyValue).DocRnos;
                        dispatch(()=>callProArcApi(buttonActionTypes.GET_DOCUMENTS,JsonPostDocuments,"")
                            .then((response)=>{
                                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                    {
                                        console.log("Error");
                                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                                        dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                                    }
                                    else
                                    {
                                        console.log("Success");
                                        let docs = (response as any as PaDocument[]).map((doc:PaDocument)=> {
                                            return {    
                                                DocId: doc.DocId,
                                                DbRno: doc.DbRno,
                                                DocRno: doc.DocRno,
                                                CurrentRevision: doc.CurrentRevision,
                                                Revisions: doc.Revisions
                                            }
                                        })
                                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentList, docs));
                                        //dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentList, response));
                                        //set revision to update
                                        let revModeSelected = store.getState().uiItems.revToUpdate; 
                                        store.getState().uiItems.documentList.forEach((doc:PaDocument)=>{
                                            let rev2Update = _.cloneDeep(
                                                    (revModeSelected === revMode.LATEST_REV) ?
                                                        (doc.Revisions[0].$ref === undefined) ? doc.Revisions[0] : doc.CurrentRevision
                                                        : doc.CurrentRevision
                                                );
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListUpdate, {DocumentID: doc.DocId, Attribute: "RevisionToUpdate",  Value: rev2Update}));  
                                        });
                                        //----------------------
                                        let DbRnoOnFirstDoc=(response as unknown as PaDocument[])[0].DbRno;
                                        Promise.all([   getRevisionCodes(DbRnoOnFirstDoc,dispatch),
                                                        getStatusCodes(DbRnoOnFirstDoc,dispatch),   
                                                        getArchiveDefinition(DbRnoOnFirstDoc,dispatch),
                                                        LoadMetaItemPresentation(DbRnoOnFirstDoc,dispatch),     
                                                    ])
                                            .then(()=>{
                                                dispatch(setUiProperty(actionTypes.SET_LOADING,containers.MAIN_CONTAINER, false))
                                            })
                                            .catch((error)=>{
                                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(error)));      
                                                dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                                                dispatch(setUiProperty(actionTypes.SET_LOADING,containers.MAIN_CONTAINER, false));
                                            })

                                        // // let JsonStatusInfoPost ={
                                        // //     "dbRno": -1
                                        // //     };
                                        // let JsonStatusInfoPost ={
                                        //     "dbRno": -1,
                                        //     "metaItemName": "STATUS"
                                        //     };
                                        // let DbRnoOnFirstDoc=(response as unknown as PaDocument[])[0].DbRno;
                                        
                                        // JsonStatusInfoPost.dbRno = DbRnoOnFirstDoc;
                                        // dispatch(()=> callProArcApi(buttonActionTypes.GET_STATUS_CODES,JsonStatusInfoPost)
                                        //             .then((response)=>{
                                        //                     if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                        //                     {
                                        //                         console.log("Error");
                                        //                         dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                                        //                         dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.REVISION_LIST_CONTAINER, true));
                                        //                     }
                                        //                     else
                                        //                     {
                                        //                         // console.log("Success");
                                        //                         // dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.statusCodes, response));
                                        //                         // let JsonCodesInfoPost ={
                                        //                         //     "dbRno": -1,
                                        //                         //     };
                                        //                         // JsonCodesInfoPost.dbRno = DbRnoOnFirstDoc;
                                        //                         // dispatch(()=> callProArcApi(buttonActionTypes.GET_REVISION_CODES,JsonCodesInfoPost)
                                        //                         //     .then((response)=>{
                                        //                         //             if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                        //                         //             {
                                        //                         //                 console.log("Error");
                                        //                         //                 dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                                        //                         //                 dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.REVISION_LIST_CONTAINER, true));
                                        //                         //             }
                                        //                         //             else
                                        //                         //             {
                                        //                         //                 console.log("Success");
                                        //                         //                 dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.revisionCodeValues, response));
                                        //                         //             }
                                        //                         //     })
                                        //                         //     .then(()=>
                                        //                         //         {dispatch(setUiProperty(actionTypes.SET_LOADING,containers.REVISION_LIST_CONTAINER, false))
                                        //                         //         dispatch(setUiProperty(actionTypes.SET_VISIBLE,containers.REVISION_LIST_CONTAINER, true));  })
                                        //                         // )
                                        //                     }
                                        //             })          
                                        //     )
                                        }
                            })
                        )
                    }   
                }
            )
            .catch(error=>
                {
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(error)));      
                    dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                    dispatch(setUiProperty(actionTypes.SET_LOADING,containers.MAIN_CONTAINER, false));
                }
            )   
        );            
    }    
} 

function getRevisionCodes(DbRnoOnFirstDoc:number,dispatch:ThunkDispatch<IState,undefined,AppActions>):Promise<void>
{
    let JsonCodesInfoPost ={
        "dbRno": -1,
        };
    JsonCodesInfoPost.dbRno = DbRnoOnFirstDoc;
    return  callProArcApi(buttonActionTypes.GET_REVISION_CODES,JsonCodesInfoPost,"")
                .then((response)=>{
                        if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                        {
                            console.log("Error");
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                            dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                        }
                        else
                        {
                            console.log("Success");
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.revisionCodeValues, response));
                        }
                })
}

function getStatusCodes(DbRnoOnFirstDoc:number,dispatch:ThunkDispatch<IState,undefined,AppActions>):Promise<void>
{
    let JsonStatusInfoPost ={
        "dbRno": -1,
        "metaItemName": "STATUS"
        };
    JsonStatusInfoPost.dbRno = DbRnoOnFirstDoc;
    return callProArcApi(buttonActionTypes.GET_STATUS_CODES,JsonStatusInfoPost,"")
                .then((response)=>{
                        if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                        {
                            console.log("Error");
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                            dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                        }
                        else
                        {
                            console.log("Success");
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.statusCodes, response));
                        }
                    })
}

function getArchiveDefinition(DbRnoOnFirstDoc:number,dispatch:ThunkDispatch<IState,undefined,AppActions>):Promise<void>
{
    let JsonPost ={
        "dbRno": -1,
        };
        JsonPost.dbRno = DbRnoOnFirstDoc;
    return callProArcApi(buttonActionTypes.GET_ARCHIVE,JsonPost,"")
                .then((response)=>{
                        if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                        {
                            console.log("Error");
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                            dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.MAIN_CONTAINER, true));
                        }
                        else
                        {
                            console.log("Success");
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.archiveDefinition, response));
                        }
                    })
}

export function SaveClick():ThunkResult<void> {
    console.log("SaveClick");
    if(store.getState().uiItems.levelToUpdate === false)
    {
        return SaveRevisions();
    }
    else
    {
        return SaveFiles(); 
    }
}

export function onVoidFiles(fiRno: readonly Number[], voidFiles: boolean):ThunkResult<void> {
    console.log("onVoidFiles", fiRno);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.SAVE_REVISIONS, true));
        
        //run sequencial
        let p = Promise.resolve();
        fiRno.forEach(values =>
            p = p.then(() => voidFile(values, voidFiles, dispatch))
            .finally(()=> {
                    //reload document data
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify({succeded: true, Message:"Reloading document data..."})));      
                    let JsonPostDocuments = {
                        "docRnos": [-1],
                        "returnOptions": "All"
                    };
                    JsonPostDocuments.docRnos = store.getState().uiItems.documentList.map((element:PaDocument) => {
                        return Number(element.DocRno);
                      });
                    dispatch(()=>callProArcApi(buttonActionTypes.GET_DOCUMENTS,JsonPostDocuments,"")
                        .then((response)=>{
                                if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                {
                                    console.log("Error");
                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                                    dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.REVISION_LIST_CONTAINER, true));
                                }
                                else
                                {
                                    console.log("Success");
                                    //set revision to update
                                    let revModeSelected = store.getState().uiItems.revToUpdate; 
                                    (response as any as PaDocument[]).forEach(
                                        (doc:PaDocument)=>{
                                            let rev2Update = _.cloneDeep(
                                                    (revModeSelected === revMode.LATEST_REV) ?
                                                        (doc.Revisions[0].$ref === undefined) ? doc.Revisions[0] : doc.CurrentRevision
                                                        : doc.CurrentRevision
                                                );
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListUpdate, {DocumentID: doc.DocId, Attribute: "CurrentRevision",  Value: doc.CurrentRevision}));
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListUpdate, {DocumentID: doc.DocId, Attribute: "Revisions",  Value: doc.Revisions}));
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListUpdate, {DocumentID: doc.DocId, Attribute: "RevisionToUpdate",  Value: rev2Update}));  
                                        }
                                    );
                                    //set level to file
                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.levelToUpdate, true)); 
                                }
                            }))
                    //clear saving proc
                    dispatch(setUiProperty(actionTypes.SET_LOADING,containers.SAVE_REVISIONS, false))
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify({succeded: true, Message:""})));
                
                    
            })
        );          
    }  
}


export function SavePDFClick(fileRnos:readonly string[], DPI: number):ThunkResult<void> {
    console.log("SavePDFClick");
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.SAVE_REVISIONS, true));

        //console.log(fileRnos)
        if(fileRnos.length===0)
        {
            //console.log( store.getState().uiItems.documentList.map((x:PaDocument)=> {
            //    return x.RevisionToUpdate.Files.map(y=>y.FileRno.toString())
            //}).flat(1));
            //console.log("All files",fileRnos);
            fileRnos=store.getState().uiItems.documentList.map((x:PaDocument)=> {
                return x.RevisionToUpdate.Files.filter(x=>x.Extension.toUpperCase() === "DWG" || x.Extension.toUpperCase() === "PDF").map(y=>y.FileRno.toString())
            }).flat(1);
        }
        else
        {
            //console.log("One file",fileRnos);
        }

        //reset saveStatus in case its a new save
        fileRnos.forEach(values=> {
            //console.log("Reset status",fileRnos);
            // dispatch(updateRevisionSaveResult({DocumentID:values.DocumentID, SaveResult: ""}));
            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values, Attribute: "SaveResult", Value: ""}));
        })

        //run sequencial
        let p = Promise.resolve();
        fileRnos.forEach(fiRno =>
            p = p.then(() => savePDFFile(fiRno,dispatch, DPI))
            .finally(()=> {
                let valuesLeft = store.getState().uiItems.newMetaItemValues
                // .filter((meta:NewMetaItemValues) =>
                //     (
                //         metaItemChanged(
                //             newMetaItemValuesInStore, 
                //             documentListInStore.filter(x=> x.RevisionToUpdate.Files.filter(y=>y.Name ===meta.DocumentID).length>0)[0].RevisionToUpdate.Files.filter(y=>y.Name ===meta.DocumentID)[0], 
                //             store.getState().uiItems.levelToUpdate
                //         )
                //     )
                // )
                
                //console.log("Finaly",valuesLeft,valuesLeft.filter((x:NewMetaItemValues)=>x.SaveResult===""),valuesLeft.filter((x:NewMetaItemValues)=>x.SaveResult==="").length === 0)
                
                //dispatch(setUiProperty(actionTypes.SET_LOADING,containers.SAVE_REVISIONS, false)) 
                if(valuesLeft.filter((x:NewMetaItemValues)=>x.SaveResult==="").length === 0)
                {
                            //reload document data
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify({succeded: true, Message:"Reloading document data..."})));      
                            let JsonPostDocuments = {
                                "docRnos": [-1],
                                "returnOptions": "All"
                            };
                            JsonPostDocuments.docRnos = store.getState().uiItems.documentList.map((element:PaDocument) => {
                                return Number(element.DocRno);
                            });
                            dispatch(()=>callProArcApi(buttonActionTypes.GET_DOCUMENTS,JsonPostDocuments,"")
                                .then((response)=>{
                                        if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                        {
                                            console.log("Error");
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                                            dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.PDF_CONVERT_CONTAINER, true));
                                        }
                                        else
                                        {
                                            console.log("Success");
                                            //set revision to update
                                            let revModeSelected = store.getState().uiItems.revToUpdate; 
                                            (response as any as PaDocument[]).forEach(
                                                (doc:PaDocument)=>{
                                                    let rev2Update = _.cloneDeep(
                                                            (revModeSelected === revMode.LATEST_REV) ?
                                                                (doc.Revisions[0].$ref === undefined) ? doc.Revisions[0] : doc.CurrentRevision
                                                                : doc.CurrentRevision
                                                        );
                                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListUpdate, {DocumentID: doc.DocId, Attribute: "CurrentRevision",  Value: doc.CurrentRevision}));
                                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListUpdate, {DocumentID: doc.DocId, Attribute: "Revisions",  Value: doc.Revisions}));
                                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListUpdate, {DocumentID: doc.DocId, Attribute: "RevisionToUpdate",  Value: rev2Update}));  
                                                }
                                            );
                                            //set level to file
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.levelToUpdate, true)); 
                                        }
                                    }))
                            //clear saving proc
                            dispatch(setUiProperty(actionTypes.SET_LOADING,containers.SAVE_REVISIONS, false))
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify({succeded: true, Message:""})));
                }
            })
        )
        
    }
}

export function CreateCommentSheetClick(fileRnos:readonly string[]):ThunkResult<void> {
    console.log("CreateCommentSheetClick");
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.SAVE_REVISIONS, true));

        //console.log(fileRnos)
        if(fileRnos.length===0)
        {
            //console.log( store.getState().uiItems.documentList.map((x:PaDocument)=> {
            //    return x.RevisionToUpdate.Files.map(y=>y.FileRno.toString())
            //}).flat(1));
            //console.log("All files",fileRnos);
            fileRnos=store.getState().uiItems.documentList.map((x:PaDocument)=> {
                return x.RevisionToUpdate.Files.filter(x=>x.Extension.toUpperCase() === "PDF").map(y=>y.FileRno.toString())
            }).flat(1);
        }
        else
        {
            //console.log("One file",fileRnos);
        }

        const JsonPost = {"fileRnos": fileRnos };
        dispatch(()=>
                {  
                    const postObject=JSON.stringify(JsonPost); 
                    const completeURL:string = apiUrl + "/MLayer/CreateCommentSheet";
                    return fetch(completeURL, {
                        method: "POST",
                        headers: new Headers ({
                                "Cache-Control": "no-cache",
                                "Content-Type": "application/json",
                                credentials: "include",
                                Authorization: `Bearer ${store.getState().oidc?.access_token}`,
                                "Ocp-Apim-Subscription-Key": store.getState().appSettings.apimSubKey
                                }),
                        body: postObject
                        })
                        .then((response) => response.blob())
                        .then((blob) => {
                            // Create blob link to download
                            const url = window.URL.createObjectURL(new Blob([blob]),);
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download',`commentSheet.xlsx`,);
                            // Append to html link element page
                            document.body.appendChild(link);
                            // Start download
                            link.click();
                            // Clean up and remove the link
                            link.parentNode!.removeChild(link);
                            dispatch(setUiProperty(actionTypes.SET_LOADING,containers.SAVE_REVISIONS, false));
                        })
                        .catch(error=>
                            {
                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(error)));      
                                //dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.SEARCH_CONTAINER, true));
                                dispatch(setUiProperty(actionTypes.SET_LOADING,containers.SEARCH_CONTAINER, false));
                            })
                }
            );   
    }
}

export function SaveFiles():ThunkResult<void> {
    console.log("SaveFiles");
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.SAVE_REVISIONS, true));
        
        let newMetaItemValuesInStore:NewMetaItemValues[] = store.getState().uiItems.newMetaItemValues;
        let documentListInStore:PaDocument[] = store.getState().uiItems.documentList;

        let fileValuesToSave:NewMetaItemValues[] = newMetaItemValuesInStore.filter((meta:NewMetaItemValues) => 
            (
                metaItemChanged(
                        newMetaItemValuesInStore, 
                        documentListInStore.filter(x=> x.RevisionToUpdate.Files.filter(y=>y.Name ===meta.DocumentID).length>0)[0].RevisionToUpdate.Files.filter(y=>y.Name ===meta.DocumentID)[0], 
                        store.getState().uiItems.levelToUpdate
                    )
            )
        )

        //console.log("revisionValuesToSave2",fileValuesToSave);        
        //console.log("documentListInStore2",documentListInStore);       
        //reset saveStatus in case its a new save
        fileValuesToSave.forEach(values=> {
            // dispatch(updateRevisionSaveResult({DocumentID:values.DocumentID, SaveResult: ""}));
            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: ""}));
        })
        
        //run sequencial
        let p = Promise.resolve();
        fileValuesToSave.forEach(values =>
            p = p.then(() => saveFile(values,dispatch))
            .finally(()=> {
                let valuesLeft = store.getState().uiItems.newMetaItemValues.filter((meta:NewMetaItemValues) =>
                    (
                        metaItemChanged(
                            newMetaItemValuesInStore, 
                            documentListInStore.filter(x=> x.RevisionToUpdate.Files.filter(y=>y.Name ===meta.DocumentID).length>0)[0].RevisionToUpdate.Files.filter(y=>y.Name ===meta.DocumentID)[0], 
                            store.getState().uiItems.levelToUpdate
                        )
                    )
                )
                
                //console.log("Finaly",valuesLeft,valuesLeft.filter((x:NewMetaItemValues)=>x.SaveResult===""),valuesLeft.filter((x:NewMetaItemValues)=>x.SaveResult==="").length === 0)
                
                //dispatch(setUiProperty(actionTypes.SET_LOADING,containers.SAVE_REVISIONS, false)) 
                if(valuesLeft.filter((x:NewMetaItemValues)=>x.SaveResult==="").length === 0)
                {
                    //reload document data
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify({succeded: true, Message:"Reloading document data..."})));      
                    let JsonPostDocuments = {
                        "docRnos": [-1],
                        "returnOptions": "All"
                    };
                    JsonPostDocuments.docRnos = store.getState().uiItems.documentList.map((element:PaDocument) => {
                        return Number(element.DocRno);
                      });
                    dispatch(()=>callProArcApi(buttonActionTypes.GET_DOCUMENTS,JsonPostDocuments,"")
                        .then((response)=>{
                                if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                {
                                    console.log("Error");
                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                                    dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.REVISION_LIST_CONTAINER, true));
                                }
                                else
                                {
                                    console.log("Success");
                                    //set revision to update
                                    let revModeSelected = store.getState().uiItems.revToUpdate; 
                                    (response as any as PaDocument[]).forEach(
                                        (doc:PaDocument)=>{
                                            let rev2Update = _.cloneDeep(
                                                    (revModeSelected === revMode.LATEST_REV) ?
                                                        (doc.Revisions[0].$ref === undefined) ? doc.Revisions[0] : doc.CurrentRevision
                                                        : doc.CurrentRevision
                                                );
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListUpdate, {DocumentID: doc.DocId, Attribute: "CurrentRevision",  Value: doc.CurrentRevision}));
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListUpdate, {DocumentID: doc.DocId, Attribute: "Revisions",  Value: doc.Revisions}));
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListUpdate, {DocumentID: doc.DocId, Attribute: "RevisionToUpdate",  Value: rev2Update}));  
                                        }
                                    );
                                    //set level to file
                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.levelToUpdate, true)); 
                                }
                            }))
                    //clear saving proc
                    dispatch(setUiProperty(actionTypes.SET_LOADING,containers.SAVE_REVISIONS, false))
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify({succeded: true, Message:""})));
                }
                    
            })
        );          
    }    
} 

export function metaItemChanged(newMetaItemValues:NewMetaItemValues[], row:PaFile|PaDocument, fileLevelToUpdate: boolean)
{
  let changed = false;
  let metaItemChanged:any = null;
  let metaItemsToCheck:MetaItem[] = [];
  if(fileLevelToUpdate)
  {
    metaItemChanged = newMetaItemValues.filter(x=>x.DocumentID === (row as unknown as PaFile).Name).length > 0 ? newMetaItemValues.filter(x=>x.DocumentID === (row as unknown as PaFile).Name)[0] : null;
    metaItemsToCheck = (row as unknown as PaFile).MetaItems;
  }
  else
  {
    metaItemChanged = newMetaItemValues.filter(x=>x.DocumentID === (row as unknown as PaDocument).DocId).length > 0 ? newMetaItemValues.filter(x=>x.DocumentID === (row as unknown as PaDocument).DocId)[0] : null;
    metaItemsToCheck = (row as unknown as PaDocument).RevisionToUpdate.MetaItems;
  }
  if(metaItemChanged!== null)
  {
          Object.keys(metaItemChanged).every( key => {
              //console.log("key",key,metaItemChanged[key])
              if(metaItemChanged[key] !== (metaItemsToCheck.filter(x=>x.Name===key).length > 0 ? metaItemsToCheck.filter(x=>x.Name === key)[0].Value : "") && key !=="DocumentID" && key !=="SaveResult" && key !=="NewRevision")
              {
                changed=true;
                return false; 
              }
              return true;
          });
  }
  return changed;
}

export function SaveRevisions():ThunkResult<void> {
    console.log("SaveRevisions");
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        //let postJson;
        // dispatch(setUiProperty(actionTypes.SET_VISIBLE,containers.REVISION_LIST_CONTAINER, true));
        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.SAVE_REVISIONS, true));
        // dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.REVISION_LIST_CONTAINER, false));
        

        let newMetaItemValuesInStore = store.getState().uiItems.newMetaItemValues;
        let documentListInStore = store.getState().uiItems.documentList;
        //console.log("newMetaItemValuesInStore",newMetaItemValuesInStore);        
        //console.log("documentListInStore",documentListInStore);

        let revisionValuesToSave:NewMetaItemValues[] = newMetaItemValuesInStore.filter((x:NewMetaItemValues) =>
            (
                (x.STATUS !== (documentListInStore.filter((y:PaDocument)=>y.DocId===x.DocumentID)[0].RevisionToUpdate.MetaItems.filter((x:MetaItem)=>x.Name==="STATUS").length > 0 ? documentListInStore.filter((y:PaDocument)=>y.DocId===x.DocumentID)[0].RevisionToUpdate.MetaItems.filter((x:MetaItem)=>x.Name==="STATUS")[0].Value : "") 
                && x.STATUS !== "" && x.STATUS !== undefined) 
                ||
                (x.DESCRIPT !== (documentListInStore.filter((y:PaDocument)=>y.DocId===x.DocumentID)[0].RevisionToUpdate.MetaItems.filter((x:MetaItem)=>x.Name==="DESCRIPT").length > 0 ? documentListInStore.filter((y:PaDocument)=>y.DocId===x.DocumentID)[0].RevisionToUpdate.MetaItems.filter((x:MetaItem)=>x.Name==="DESCRIPT")[0].Value : "")
                && x.DESCRIPT !== "" && x.DESCRIPT !== undefined)
                ||
                (x.REVISION !== (documentListInStore.filter((y:PaDocument)=>y.DocId===x.DocumentID)[0].RevisionToUpdate.MetaItems.filter((x:MetaItem)=>x.Name==="REVISION").length > 0 ? documentListInStore.filter((y:PaDocument)=>y.DocId===x.DocumentID)[0].RevisionToUpdate.MetaItems.filter((x:MetaItem)=>x.Name==="REVISION")[0].Value : "")
                && x.REVISION !== "" && x.REVISION !== undefined)
                ||
                //( x.NewRevision !== undefined ? x.NewRevision : false !== false)  
                ( x.NewRevision !== undefined ? x.NewRevision : false)  
            )
        )
        //console.log("revisionValuesToSave2",revisionValuesToSave);        
        //console.log("documentListInStore2",documentListInStore);       
        //reset saveStatus in case its a new save
        revisionValuesToSave.forEach(values=> {
            // dispatch(updateRevisionSaveResult({DocumentID:values.DocumentID, SaveResult: ""}));
            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: ""}));
        })
        
        //run sequencial
        let p = Promise.resolve();
        revisionValuesToSave.forEach(values =>
            p = p.then(() => saveRevision(values,dispatch))
            .finally(()=> {
                let valuesLeft = store.getState().uiItems.newMetaItemValues.filter((x:NewMetaItemValues) =>
                    (
                        (x.STATUS !== (documentListInStore.filter((y:PaDocument)=>y.DocId===x.DocumentID)[0].RevisionToUpdate.MetaItems.filter((x:MetaItem)=>x.Name==="STATUS").length > 0 ? documentListInStore.filter((y:PaDocument)=>y.DocId===x.DocumentID)[0].RevisionToUpdate.MetaItems.filter((x:MetaItem)=>x.Name==="STATUS")[0].Value : "") 
                        && x.STATUS !== "" && x.STATUS !== undefined) 
                        ||
                        (x.DESCRIPT !== (documentListInStore.filter((y:PaDocument)=>y.DocId===x.DocumentID)[0].RevisionToUpdate.MetaItems.filter((x:MetaItem)=>x.Name==="DESCRIPT").length > 0 ? documentListInStore.filter((y:PaDocument)=>y.DocId===x.DocumentID)[0].RevisionToUpdate.MetaItems.filter((x:MetaItem)=>x.Name==="DESCRIPT")[0].Value : "")
                        && x.DESCRIPT !== "" && x.DESCRIPT !== undefined)
                        ||
                        (x.REVISION !== (documentListInStore.filter((y:PaDocument)=>y.DocId===x.DocumentID)[0].RevisionToUpdate.MetaItems.filter((x:MetaItem)=>x.Name==="REVISION").length > 0 ? documentListInStore.filter((y:PaDocument)=>y.DocId===x.DocumentID)[0].RevisionToUpdate.MetaItems.filter((x:MetaItem)=>x.Name==="REVISION")[0].Value : "")
                        && x.REVISION !== "" && x.REVISION !== undefined)
                        ||
                        //( x.NewRevision !== undefined ? x.NewRevision: false !== false) 
                        ( x.NewRevision !== undefined ? x.NewRevision: false) 
                    )
                )
                
                
                //console.log("Finaly",valuesLeft,valuesLeft.filter((x:NewMetaItemValues)=>x.SaveResult===""),valuesLeft.filter((x:NewMetaItemValues)=>x.SaveResult==="").length === 0)
                
                //dispatch(setUiProperty(actionTypes.SET_LOADING,containers.SAVE_REVISIONS, false)) 
                if(valuesLeft.filter((x:NewMetaItemValues)=>x.SaveResult==="").length === 0)
                {
                    //reload document data
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify({succeded: true, Message:"Reloading document data..."})));      
                    let JsonPostDocuments = {
                        "docRnos": [-1],
                        "returnOptions": "All"
                    };
                    JsonPostDocuments.docRnos = store.getState().uiItems.documentList.map((element:PaDocument) => {
                        return Number(element.DocRno);
                      });
                    dispatch(()=>callProArcApi(buttonActionTypes.GET_DOCUMENTS,JsonPostDocuments,"")
                        .then((response)=>{
                                if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                                {
                                    console.log("Error");
                                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                                    dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.REVISION_LIST_CONTAINER, true));
                                }
                                else
                                {
                                    console.log("Success");
                                    //dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentList, response));
                                    //set revision to update
                                    let revModeSelected = store.getState().uiItems.revToUpdate; 
                                    (response as any as PaDocument[]).forEach(
                                        (doc:PaDocument)=>{
                                            let rev2Update = _.cloneDeep(
                                                    (revModeSelected === revMode.LATEST_REV) ?
                                                        (doc.Revisions[0].$ref === undefined) ? doc.Revisions[0] : doc.CurrentRevision
                                                        : doc.CurrentRevision
                                                );
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListUpdate, {DocumentID: doc.DocId, Attribute: "CurrentRevision",  Value: doc.CurrentRevision}));
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListUpdate, {DocumentID: doc.DocId, Attribute: "Revisions",  Value: doc.Revisions}));
                                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListUpdate, {DocumentID: doc.DocId, Attribute: "RevisionToUpdate",  Value: rev2Update}));  
                                        }
                                    );
                                }
                            }))
                    //clear saving proc
                    dispatch(setUiProperty(actionTypes.SET_LOADING,containers.SAVE_REVISIONS, false))
                    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify({succeded: true, Message:""})));
                }
                    
            })
        );
        //if async would not lock DB in triggers...
        // Promise.all(revisionValuesToSave.map(values => saveRevision(values,dispatch)))
        //             .then(()=> {
        //                 //Set info container and buttons as enabled
        //                 console.log("Set info container and buttons as enabled");
        //                 // dispatch(updateImportStage(uiItemNames.dssUploaded,true))
        //                 // dispatch(findDocumentsForFiles())
        //                 dispatch(setUiProperty(actionTypes.SET_LOADING,containers.SAVE_REVISIONS, false));
        //             })
        //             .catch(error => {
        //                 //Set info container and buttons as enabled
        //                 console.log("Set info container Error and buttons as enabled");
        //                 // dispatch(updateImportStage(uiItemNames.dssUploaded,true))
        //                 console.log(error);
        //                 dispatch(setUiProperty(actionTypes.SET_LOADING,containers.SAVE_REVISIONS, false));
        //             })            
    }    
} 

export function TransferDocuments(docPath:docPathValue):ThunkResult<void> {
    console.log("TransferDocuments", docPath);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{
        //let postJson;
        // dispatch(setUiProperty(actionTypes.SET_VISIBLE,containers.REVISION_LIST_CONTAINER, true));
        dispatch(setUiProperty(actionTypes.SET_LOADING,containers.TRANSFER_DOCUMENTS, true));
        // dispatch(setUiProperty(actionTypes.SET_ERRORED,containers.REVISION_LIST_CONTAINER, false));
              
        let documentListInStore = store.getState().uiItems.documentList;
        //console.log("documentListInStore",documentListInStore);

        //reset saveStatus in case its a new save
        documentListInStore.forEach((values:PaDocument)=> {
            // dispatch(updateRevisionSaveResult({DocumentID:values.DocumentID, SaveResult: ""}));
            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocId, Attribute: "SaveResult", Value: ""}));
        })
        
        //run sequencial
        let p = Promise.resolve();
        documentListInStore.forEach((value:PaDocument) =>
            p = p.then(() => transferDocument(value,docPath,dispatch))
            .finally(()=> {
                console.log("finally");
                dispatch(setUiProperty(actionTypes.SET_LOADING,containers.TRANSFER_DOCUMENTS, false))
                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify({succeded: true, Message:""})));   
            })
        );
        
        
        //if async would not lock DB in triggers...
        // Promise.all(revisionValuesToSave.map(values => saveRevision(values,dispatch)))
        //             .then(()=> {
        //                 //Set info container and buttons as enabled
        //                 console.log("Set info container and buttons as enabled");
        //                 // dispatch(updateImportStage(uiItemNames.dssUploaded,true))
        //                 // dispatch(findDocumentsForFiles())
        //                 dispatch(setUiProperty(actionTypes.SET_LOADING,containers.SAVE_REVISIONS, false));
        //             })
        //             .catch(error => {
        //                 //Set info container and buttons as enabled
        //                 console.log("Set info container Error and buttons as enabled");
        //                 // dispatch(updateImportStage(uiItemNames.dssUploaded,true))
        //                 console.log(error);
        //                 dispatch(setUiProperty(actionTypes.SET_LOADING,containers.SAVE_REVISIONS, false));
        //             })            
    }    
} 

export function SetErrorMsgVisible(val:boolean):ThunkResult<void> {
    console.log("SetErrorMsgVisible",val);
    return (dispatch:ThunkDispatch<IState,undefined,AppActions>)=>{    
        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.errorMsgVisible, val));   
    }    
} 

export function transferDocument(value: PaDocument, docPath:docPathValue, dispatch:ThunkDispatch<IState,undefined,AppActions>):Promise<void>
{
    // dispatch(updateRevisionSaveResult({DocumentID:values.DocumentID, SaveResult: "Saving revision..."}));
    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:value.DocId, Attribute: "SaveResult", Value: "Transfering document..."}));
    console.log("transferDocument");
    //console.log("value",value);
    let Json = getRevisionsJson;
    Json.docRno = value.DocRno;
    let action = buttonActionTypes.TRANSFER_FROM_FDV_TO_TOS;
    if(docPath === docPathValue.historisk) action = buttonActionTypes.TRANSFER_HISTORISK_DOCUMENTS;
    if(docPath === docPathValue.proteknisk) action = buttonActionTypes.TRANSFER_FROM_PROTECH_TO_TOS;

    return callProArcApi(action,Json,"")
            .then((response)=>
                {
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        //console.log(response);
                        if(isErrorJsonObject(JSON.stringify(response)))
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:value.DocId, Attribute: "SaveResult", Value: JSON.stringify((response as unknown as any).Message)}));
                            // dispatch(updateRevisionSaveResult({DocumentID:values.DocumentID, SaveResult: JSON.stringify((response as unknown as any).Message)}));
                        else
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:value.DocId, Attribute: "SaveResult", Value: JSON.stringify(response)}));
                            // dispatch(updateRevisionSaveResult({DocumentID:values.DocumentID, SaveResult: JSON.stringify(response)}));
                    }
                    else
                    {
                        console.log("Success");
                        //console.log(response);
                        let val = JSON.stringify((response as unknown as any).message)!==undefined ? 
                                            (response as unknown as any).message : 
                                            JSON.stringify((response as unknown as any).Message)!==undefined ? JSON.stringify((response as unknown as any).Message):                                        
                                            response;
                        //console.log("Val",val);
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:value.DocId, Attribute: "SaveResult", Value: val}));
                    }   
                })
        .catch(error=> {
            console.log(error)
            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:value.DocId, Attribute: "SaveResult", Value: JSON.stringify(error)}));
            // dispatch(updateRevisionSaveResult({DocumentID:values.DocumentID, SaveResult: JSON.stringify(error)}));
        })               
}

export function saveRevision(values: NewMetaItemValues,dispatch:ThunkDispatch<IState,undefined,AppActions>):Promise<void>
{
    // dispatch(updateRevisionSaveResult({DocumentID:values.DocumentID, SaveResult: "Saving revision..."}));
    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: "Saving revision..."}));
    console.log("saveRevision");
    //console.log("values",values);
    let Json = formRevisionToUpdate(values);
    
    return callProArcApi(buttonActionTypes.SAVE_REVISION,Json,"")
            .then((response)=>
                {
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        //console.log(response);
                        if(isErrorJsonObject(JSON.stringify(response)))
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: JSON.stringify((response as unknown as any).Message)}));
                            // dispatch(updateRevisionSaveResult({DocumentID:values.DocumentID, SaveResult: JSON.stringify((response as unknown as any).Message)}));
                        else
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: JSON.stringify(response)}));
                            // dispatch(updateRevisionSaveResult({DocumentID:values.DocumentID, SaveResult: JSON.stringify(response)}));
                    }
                    else
                    {
                        console.log("Success");
                        //console.log(response);
                        //console.log((response as unknown as any)._succeeded)
                        if((response as unknown as any)._succeeded)
                        {
                            // let newRev = (values.NewRevision!== undefined) ? values.NewRevision : false
                            // if(newRev)
                            // {
                            //     dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListUpdateAfterSuccess, {DocumentID: values.DocumentID, Rev: (response as unknown as any)._success}));
                            // }
                            // else
                            // {
                                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListUpdate, {DocumentID: values.DocumentID, Attribute: "RevisionToUpdate",  Value: (response as unknown as any)._success}));
                            // }
                            
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: "Revision saved"}));
                            // dispatch(updateRevisionSaveResult({DocumentID:values.DocumentID, SaveResult: "Revision saved"}));  
                            let Json = {DocumentID: values.DocumentID, Attribute: "NewRevision", Value: false};
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, Json));
                        }
                        else
                        {
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: JSON.stringify((response as unknown as any)._failure)}));
                            // dispatch(updateRevisionSaveResult({DocumentID:values.DocumentID, SaveResult: JSON.stringify((response as unknown as any)._failure)}));  
                        }
                    }   
                })
        .catch(error=> {
            console.log(error)
            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: JSON.stringify(error)}));
            // dispatch(updateRevisionSaveResult({DocumentID:values.DocumentID, SaveResult: JSON.stringify(error)}));
        })               
}

export function saveFile(values: NewMetaItemValues,dispatch:ThunkDispatch<IState,undefined,AppActions>):Promise<void>
{
    // dispatch(updateRevisionSaveResult({DocumentID:values.DocumentID, SaveResult: "Saving revision..."}));
    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: "Saving file..."}));
    console.log("saveFile");
    //console.log("values",values);
    let Json = formFileToUpdate(values);
    
    return callProArcApi(buttonActionTypes.SAVE_FILE,Json,"")
            .then((response)=>
                {
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        //console.log(response);
                        if(isErrorJsonObject(JSON.stringify(response)))
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: JSON.stringify((response as unknown as any).Message)}));
                        else
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: JSON.stringify(response)}));
                    }
                    else
                    {
                        console.log("Success");
                        //console.log(response);
                        //console.log((response as unknown as any)._succeeded)
                        if((response as unknown as any)._succeeded)
                        {
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListFileUpdate, {DocumentID: values.DocumentID, Attribute: "RevisionToUpdate",  Value: (response as unknown as any)._success}));
                            //console.log('dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: "File saved..."}));')
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: "File saved"}));
                        }
                        else
                        {
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: JSON.stringify((response as unknown as any)._failure)}));
                        }
                    }   
                })
        .catch(error=> {
            console.log(error)
            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: JSON.stringify(error)}));
        })               
}

export function voidFile(fiRno: Number,voidFiles: boolean,dispatch:ThunkDispatch<IState,undefined,AppActions>):Promise<void>
{
    // dispatch(updateRevisionSaveResult({DocumentID:values.DocumentID, SaveResult: "Saving revision..."}));
    let Json = {
                "fileRno": fiRno
                };
    
    console.log("voidFile", fiRno, voidFiles, Json);
  
    return callProArcApi( voidFiles === true ? buttonActionTypes.VOID_FILE: buttonActionTypes.UNDO_VOID_FILE,Json,"")
            .then((response)=>
                {
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        console.log(response);
                        // if(isErrorJsonObject(JSON.stringify(response)))
                        //     dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: JSON.stringify((response as unknown as any).Message)}));
                        // else
                        //     dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: JSON.stringify(response)}));
                    }
                    else
                    {
                        console.log("Success");
                        //console.log(response);
                        //console.log((response as unknown as any)._succeeded)
                        // if((response as unknown as any)._succeeded)
                        // {
                        //     dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListFileUpdate, {DocumentID: values.DocumentID, Attribute: "RevisionToUpdate",  Value: (response as unknown as any)._success}));
                        //     //console.log('dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: "File saved..."}));')
                        //     dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: "File saved"}));
                        // }
                        // else
                        // {
                        //     dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: JSON.stringify((response as unknown as any)._failure)}));
                        // }
                    }   
                })
        .catch(error=> {
            console.log(error)
            //dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: JSON.stringify(error)}));
        })               
}

export function savePDFFile(fiRno: string,dispatch:ThunkDispatch<IState,undefined,AppActions>, DPI: number):Promise<void>
{
    dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:fiRno.toString(), Attribute: "SaveResult", Value: "Converting file..."}));
    console.log("savePDFFile");
    //console.log("fiRno",fiRno);
    let Json = {"fileRno": fiRno, "DPI": DPI};;
    
    return callProArcApi(buttonActionTypes.CONVERT_FILE,Json,"")
            .then((response)=>
                {
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        //console.log(response);
                        if(isErrorJsonObject(JSON.stringify(response)))
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:fiRno, Attribute: "SaveResult", Value: JSON.stringify((response as unknown as any).Message)}));
                        else
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:fiRno, Attribute: "SaveResult", Value: JSON.stringify(response)}));
                    }
                    else
                    {
                        console.log("Success");
                        //console.log(response);
                        //console.log((response as unknown as any).succeded)
                        if((response as unknown as any).succeded)
                        {
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.documentListFileUpdate, {DocumentID: fiRno, Attribute: "RevisionToUpdate",  Value: (response as unknown as any).success}));
                            //console.log('dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:values.DocumentID, Attribute: "SaveResult", Value: "File converted"}));')
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:fiRno, Attribute: "SaveResult", Value: "File converted"}));
                        }
                        else
                        {
                            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:fiRno, Attribute: "SaveResult", Value: JSON.stringify(response)}));
                        }
                    }   
                })
        .catch(error=> {
            console.log(error)
            dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.newMetaItemValues, {DocumentID:fiRno, Attribute: "SaveResult", Value: JSON.stringify(error)}));
        })               
}

export function getValidValues(value: MetaItemPresentation,dispatch:ThunkDispatch<IState,undefined,AppActions>):Promise<void>
{
    console.log("getValidValues");
    //console.log("value",value);
    let Json = {
        "dbRno": store.getState().uiItems.documentList[0].DbRno,
        "metaItemName": `FILE;${value.Name}`,
        "filter": "",
        "dependencies": []
      }
    return callProArcApi(buttonActionTypes.GET_VALID_METAVALUES,Json,"")
            .then((response)=>
                {
                    if(response instanceof ReqError || isErrorJsonObject(JSON.stringify(response)))
                    {
                        console.log("Error");
                        //console.log(response);
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(response)));      
                    }
                    else
                    {
                        console.log("Success");
                        //console.log(response);
                        dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.MetaItemValidValues, response));  
                    }   
                })
            .catch(error=> {
                console.log(error)
                dispatch(setStateItem(actionTypes.SET_ITEMS, uiItemNames.infoContainerItems, JSON.stringify(error)));      
            })
    }
                   
function formRevisionToUpdate(values: NewMetaItemValues):Object {
    let newRev = (values.NewRevision!== undefined) ? values.NewRevision : false;
    let documentListInStore = store.getState().uiItems.documentList;
    let latestRevision = _.cloneDeep(documentListInStore.filter((x:PaDocument)=>x.DocId===values.DocumentID)[0].RevisionToUpdate);
    let revisionToUpdate:any;
    if(newRev)
    {
        revisionToUpdate = _.cloneDeep(NewRevisionJson);
        revisionToUpdate.dbRno = latestRevision.DbRno;
        revisionToUpdate.DocRno = latestRevision.DocRno;
        revisionToUpdate.Status = store.getState().uiItems.archiveDefinition!.RevisionDefinition.StatusDefinition.Default;
        revisionToUpdate.MetaItems.filter((x:MetaItem)=>x.Name==="STATUS")[0].Value = store.getState().uiItems.archiveDefinition!.RevisionDefinition.StatusDefinition.Default;
    }
    else
    {
        revisionToUpdate=latestRevision;
        revisionToUpdate.RevisionLog=[]
    }

    console.log("revisionToUpdate")
    //console.log(revisionToUpdate)
    //set new values
    //set description value
    if(values.DESCRIPT!== undefined && values.DESCRIPT !== "")
    {
        if(revisionToUpdate.MetaItems.filter((x:MetaItem)=>x.Name==="DESCRIPT").length>0)
        {
            revisionToUpdate.MetaItems.filter((x:MetaItem)=>x.Name==="DESCRIPT")[0].Value = values.DESCRIPT;
        }
        else
        {
            revisionToUpdate.MetaItems.push({Name: "DESCRIPT", Value: values.DESCRIPT, HasMultipleValues : false})
        }
    }

    //set status value
    if(values.STATUS !== undefined && values.STATUS !== "" )
    {
        revisionToUpdate.Status = values.STATUS;
        revisionToUpdate.MetaItems.filter((x:MetaItem)=>x.Name==="STATUS")[0].Value = values.STATUS;
    }
     
    //set revision code
    if(values.REVISION!== undefined && values.REVISION !== "")
    {
        revisionToUpdate.RevisionCode = values.REVISION;
        if(revisionToUpdate.MetaItems.filter((x:MetaItem)=>x.Name==="REVISION").length>0)
        {
            revisionToUpdate.MetaItems.filter((x:MetaItem)=>x.Name==="REVISION")[0].Value = values.REVISION;
        }
        else
        {
            revisionToUpdate.MetaItems.push({Name: "REVISION", Value: values.REVISION, HasMultipleValues : false})
        }
    }

    let Json = newRev ? saveRevisionJson: saveRevisionJson; 
    Json.revision=revisionToUpdate;
    
    console.log("revisionToUpdate Json")
    //console.log(Json)

    return _.cloneDeep(Json);
}

function formFileToUpdate(values: NewMetaItemValues):Object {

    let documentListInStore:PaDocument[] = store.getState().uiItems.documentList;
    let fileToUpdate = _.cloneDeep( documentListInStore.filter(x=> x.RevisionToUpdate.Files.filter(y=>y.Name ===values.DocumentID).length>0)[0].RevisionToUpdate.Files.filter(y=>y.Name === values.DocumentID)[0] );

    console.log("fileToUpdate")
    //console.log(fileToUpdate)
    //set new values
    Object.keys(values).forEach(key => {
        //console.log("key",key, values[key])
        if(values[key] !== (fileToUpdate.MetaItems.filter(x=>x.Name===key).length > 0 ? fileToUpdate.MetaItems.filter(x=>x.Name === key)[0].Value : "") && key !=="DocumentID" && key !=="SaveResult" && key !=="NewRevision")
        {
            fileToUpdate.MetaItems.filter(x=>x.Name === key)[0].Value = values[key];
        }
    });

    let Json = {
        "file": {}
    }; 
    Json.file= fileToUpdate;
    
    //console.log("fileToUpdate Json")
    //console.log(Json)

    return _.cloneDeep(Json);
}

function isErrorJsonObject(strData:string) {
    try {
        let Json = JSON.parse(strData);
        // console.log("Json", Json);
        if(
            Json.hasOwnProperty("Message") &&  Json.hasOwnProperty("ExceptionMessage") &&  Json.hasOwnProperty("StackTrace")
             &&  Json.hasOwnProperty("InnerException") )
        {
            return true;    
        }
        else
        {
            if(
                Json.hasOwnProperty("errorDetails") &&  Json.hasOwnProperty("errorMessage") //&&  Json.hasOwnProperty("errorType")
            )
            {
                return true;
            }
            else
            {
                if(
                    Json.hasOwnProperty("errorType") &&  Json.hasOwnProperty("errorMessage") //&&  Json.hasOwnProperty("errorType")
                )
                {
                    return true;
                }
                else
                {
                    if(
                    Json.hasOwnProperty("ExceptionMethod") &&  Json.hasOwnProperty("StackTraceString") &&  Json.hasOwnProperty("InnerException") //&&  Json.hasOwnProperty("errorType")
                    )
                    {
                        return true;
                    }
                    else
                    {
                            return false;   
                    } 
                }
            }
        }
    } catch (e) {
        return false;
    }
}